module.exports = __webpack_public_path__ + "img/aave.cc731ac0.svg";